import withUserRolesEntity from "./../data/providers/with-user-roles";
import Entities from "./entity-component";

export default withUserRolesEntity(Entities);
